import {
    ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, Output
} from '@angular/core';
import {FillBadgeComponent} from '../fill-badge/fill-badge.component';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray} from "@angular/cdk/drag-drop";

@Component({
    selector: 'pas-index-items-list',
    standalone: true,
    imports: [FillBadgeComponent, ReactiveFormsModule, CdkDropList, CdkDrag],
    templateUrl: './index-items-list.component.html',
    styleUrl: './index-items-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndexItemsListComponent {
    @Output() itemsChange: EventEmitter<Unit[]> = new EventEmitter()
    form = new FormGroup({
        itemName: new FormControl('', Validators.required), itemShortName: new FormControl('', Validators.required),
    })

    _items: Unit[] = []

    @Input() set items(items: Unit[] | undefined) {
        this._items = items || [];
    }

    cdr = inject(ChangeDetectorRef);

    addItem(): void {
        if (this.form.invalid) return;
        const newItem: Unit = {
            id: 0,
            name: this.form.get('itemName')!.value || '',
            shortName: this.form.get('itemShortName')!.value || '',
        }
        this._items.push(newItem);
        this.itemsChange.emit(this._items);
        this.form.reset();
    }

    removeItem(item: Unit) {
        this._items = this._items.filter(i => i.name !== item.name || i.shortName !== item.shortName);
        this.itemsChange.emit(this._items);
    }

    drop(event: CdkDragDrop<any, any>) {
        const arr = [...this._items];
        moveItemInArray(arr, event.previousIndex, event.currentIndex);
        this._items = arr;
        this.itemsChange.emit(this._items);
        this.cdr.markForCheck();
    }
}
